import { render, staticRenderFns } from "./listIndex.vue?vue&type=template&id=20a8cee6&scoped=true"
import script from "./listIndex.vue?vue&type=script&lang=js"
export * from "./listIndex.vue?vue&type=script&lang=js"
import style0 from "./listIndex.vue?vue&type=style&index=0&id=20a8cee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8cee6",
  null
  
)

export default component.exports